import { render, staticRenderFns } from "./ClientEventsTab.vue?vue&type=template&id=7637f086&"
import script from "./ClientEventsTab.vue?vue&type=script&lang=js&"
export * from "./ClientEventsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports